export default __webpack_public_path__ + "static/media/slide27.9c184cbd.png";